import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { UseFormReturn } from 'react-hook-form';

import { TextFieldElement } from 'components/muiInputWrappers';
import { useTranslation } from 'react-i18next';

export type FormFields = {
  projectName?: string;
  numberService?: number;
};

type Props = {
  form: UseFormReturn;
};

function ServiceProyects({ form }: Props) {
  const { t } = useTranslation('global');

  return (
    <Box>
      <Typography>{t('common.commonProperties.serviceNumber')}:</Typography>
      <TextFieldElement
        control={form?.control}
        name="numberService"
        placeholder={t('common.commonProperties.serviceNumber')}
        size="small"
        style={{ width: '100%' }}
        type="number"
        validation={{
          minLength: {
            value: 1,
            message: t('ticket.messages.valueLessThan1')
          },
          maxLength: {
            value: 30,
            message: t('ticket.messages.valueLongerThan30')
          }
        }}
        variant="outlined"
      />
      <br />
      <br />
      <Typography>{t('common.commonProperties.serviceName')}:</Typography>
      <TextFieldElement
        control={form?.control}
        name="serviceName"
        placeholder={t('common.commonProperties.serviceName')}
        size="small"
        style={{ width: '100%' }}
        validation={{
          minLength: {
            value: 1,
            message: t('ticket.messages.valueLessThan1')
          },
          maxLength: {
            value: 240,
            message: t('ticket.messages.valueLongerThan240')
          }
        }}
        variant="outlined"
      />
    </Box>
  );
}

export default ServiceProyects;
